import { financePaymentExcludeProjectsAPI } from "@/views/FinancePaymentExcludeProjects/services/api";

export const readProjectPaymentExclude = async (projectId) => {
  const params = {};
  if (projectId !== null && projectId !== undefined && projectId !== "") {
    params.project_id = projectId;
  }
  const res = await financePaymentExcludeProjectsAPI.read(params);
  return res?.data || [];
};

export const createProjectPaymentExclude = async (payload) => {
  const res = await financePaymentExcludeProjectsAPI.create(payload);
  return res;
};

export const updateProjectPaymentExclude = async (payload) => {
  const res = await financePaymentExcludeProjectsAPI.update(payload);
  return res;
};

export const deleteProjectPaymentExclude = async (projectPaymentExcludeId) => {
  const res = await financePaymentExcludeProjectsAPI.delete({
    project_payment_exclude_id: projectPaymentExcludeId,
  });
  return res;
};

export const columns = [
  { name: "project_info", field: "resident_name", label: "Проект", align: "left", sortable: true, style: "min-width: 280px" },
  { name: "exclude_info", field: "exclude_date", label: "Исключение", align: "left", sortable: true, style: "min-width: 210px" },
  { name: "exclude_comment", field: "exclude_comment", label: "Комментарий", align: "left", sortable: true },
  { name: "employee_fio", field: "employee_fio", label: "Кто", align: "left", sortable: true, style: "min-width: 160px" },
  { name: "actions", field: "actions", label: "", align: "right", sortable: false, style: "width: 160px" },
];

